<template>
  <div :class="['carousel orderCard', isAnimate ? 'activeAnimate' : '', isSeeAll ? 'activeSeeAll' : '']">
    <div class="mainCarousel">
      <swiper ref="swiper" class="swiper" :options="swiperOption" @click="detroySeeAll">
        <!-- <swiper-slide v-show="!isSeeAll">
          <div class="item-0">
            <Step0 />
            <div class="nav-control">
              <button class="nav-next" @click="doNextToMain">Next <i>→</i></button>
            </div>
          </div>
        </swiper-slide> -->
        <swiper-slide v-for="n in steps" :key="n" v-show="!isSeeAll" :class="[isErrorAnimated && getCurrentStep(currStep) === getCurrentStep(errorStep) && 'animated']">
          <div class="item">
            <span class="number">{{ getCurrentStep(n) }}</span>
            <component
              :is="`Step${currStep}`"
              :source="dataSources"
              v-model="dataInput"
              :ref="`Step${currStep}`"
              :step="n"
              @onInvalid="handleError"
              @onAnimated="handleError"
              @onNextPage="onChangeSlide('next')"
              @onNextTextChanged="nextText = $event"
              @onSelectCard="doSelectCard"
            />
            <div class="nav-control">
              <button class="nav-prev" @click="onChangeSlide()" v-if="currStep > 0"><i>←</i> Prev</button>
              <button class="nav-next" :class="[n === 1 && 'no-back']" @click="confirmNext" v-html="getNextText" v-if="currStep < 9"></button>
              <p v-if="isError && getCurrentStep(currStep) === getCurrentStep(errorStep)" :class="['error', `step${errorStep}`]">{{ errorText }}</p>
            </div>
          </div>
          <p class="error-other" v-if="isError && getCurrentStep(currStep) === getCurrentStep(errorStep + 1)">There are errors on the form. Please fix them before continuing.</p>
        </swiper-slide>
        <!-- <swiper-slide v-show="!isSeeAll">
          <div class="item-0">
            <Step9 ref="Step9" />
          </div>
        </swiper-slide> -->
      </swiper>
    </div>
    <template v-if="currStep > 0 && currStep < 9">
      <div class="see-all">
        <div class="text">{{ getCurrentStep(currStep) }} of {{ steps }}</div>
      </div>
    </template>
    <a-modal v-model="isConfirmNext" title="Confirm">
      <p>Are you sure you completed this step?</p>
      <template slot="footer">
        <a-button key="ok" type="primary" @click="handleConfrimNext"> Ok </a-button>
      </template>
    </a-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import components from './stage';
import { get } from 'lodash';
import { empty } from '@/utils';
import UserService from '@/services/UserService';

export default {
  name: 'Carousel',
  components: {
    ...components,
    Swiper,
    SwiperSlide,
  },
  props: {
    value: {
      type: Object,
    },
    dataSources: {
      type: Object,
    },
  },
  computed: {
    swiperInstance() {
      return get(this.$refs.swiper, 'swiperInstance');
    },
    ...mapState(['settings', 'user']),
    isDesktop() {
      return !this.settings.isMobileView && !this.settings.isTabletView;
    },
    getNextText() {
      if (!empty(this.nextText)) {
        return this.nextText;
      }
      if (this.isLoading) {
        return 'Please wait...';
      }
      return 'Next <i>→</i>';
    },
    frontCards() {
      return get(this.dataSources, 'front', []);
    },
    backCards() {
      return get(this.dataSources, 'back', []);
    },
  },
  async created() {
    await this.doUserData();
  },
  data() {
    return {
      dataInput: this.value,
      steps: 8,
      errorStep: 0,
      isLoading: false,
      stepDetails: [
        'QR code',
        'Add Church Address to Church Finder',
        'Create Church Finder Profile',
        'Ordering cards',
        'Download and print what to say cards (while waiting for cards to arrive)',
        'Download best practices (implementation, what to say cards, video to introduce to church etc.)',
        'Click forward after your cards arrive. (We need them to tell us when they got the cards with an ok button, maybe we can show the tracking number if the designer puts it in)',
        'Film video for cards (after receiving cards)',
      ],
      swiperOption: {
        slidesPerView: 'auto',
        centeredSlides: true,
        autoHeight: true,
        touchRatio: 0,
        breakpoints: {
          480: {
            autoHeight: false,
          },
        },
      },
      isAnimate: false,
      isErrorAnimated: false,
      isSeeAll: false,
      isError: false,
      errorText: '',
      currStep: 0,
      nextText: '',
      isConfirmNext: false,
    };
  },
  methods: {
    async doUserData() {
      const res = await UserService.doGetUserInfo1();
      let step = res.action_box_step;
      if (step > 0) {
        this.currStep = step + 1;
      } else {
        this.currStep = step;
      }
    },
    confirmNext() {
      if (this.currStep > 0) {
        this.isConfirmNext = true;
      } else {
        this.handleConfrimNext();
      }
    },
    getCurrentStep(n) {
      return n;
    },
    handleError([value, step, errorText]) {
      this.errorText = errorText;
      this.isError = value;
      this.isErrorAnimated = false;
      if (value) {
        this.errorStep = step;
        setTimeout(() => {
          this.isErrorAnimated = true;
        }, 300);
      } else {
        this.errorStep = 0;
      }
    },
    onClickPagination(ind) {
      this.currStep = ind;
      this.swiperInstance.slideTo(ind);
      this.isAnimate = true;
      setTimeout(() => {
        this.isAnimate = false;
      }, 800);
    },
    seeAll() {
      if (this.isSeeAll) {
        this.detroySeeAll();
      } else {
        this.swiperInstance.params.touchRatio = 1;
        this.isSeeAll = true;
      }
    },
    detroySeeAll() {
      this.isSeeAll = false;
      this.swiperInstance.params.touchRatio = 0;
    },
    handleConfrimNext() {
      this.isConfirmNext = false;
      this.onChangeSlide('next');
    },
    async onChangeSlide(type) {
      if (type === 'next') {
        if (this.currStep <= this.steps) {
          await UserService.updateActionStep({ step: this.currStep });
          this.swiperInstance.slideNext();
          this.currStep++;
        }
      } else {
        this.swiperInstance.slidePrev();
        if (this.currStep > 0) {
          this.currStep--;
          this.nextText = '';
        }
      }
    },
    doNextToMain() {
      this.swiperInstance.slideNext(300);
      this.currStep = 1;
    },
    doSelectCard(card) {
      this.$emit('onImgSource', card);
    },
    doSetCardSelected(type, index) {
      switch (type) {
        case 'front':
          this.$refs[`Step1`][0].doSetCardSelected(index);
          break;
        case 'back':
          this.$refs[`Step2`][0].doSetCardSelected(index);
          break;
      }
    },
  },
};
</script>

<style lang="scss">
.carousel.orderCard {
  padding: 0;
  padding-bottom: 60px;
  position: relative;
  width: 100%;
  overflow: hidden;

  .swiper {
    &-wrapper {
      align-items: center;
    }
    &-container {
      transition: all 0.3s;
    }
    &-slide {
      // max-width: 800px;
      width: 100%;
      padding: 15px;
      opacity: 0;
      transition: all 0.3s;
      &-active {
        opacity: 1;
        .error-other {
          text-align: center;
          background-color: #df3030;
          color: #fff;
          margin-top: 0.6em;
          border-radius: 8px;
          padding: 0.5em;
        }
      }
      &.animated {
        animation: shake-box 0.3s ease-in-out 3;
      }
      .item {
        width: 100%;
        min-height: 50px;
        background: #fff;
        border-radius: 10px;
        box-shadow: rgba(#000, 0.25) 0 0 30px;
        position: relative;
        &-0 {
          background: #007ce2;
          border-radius: 0 0 10px 10px;
          .content-item * {
            color: #fff;
          }
          .nav-control {
            button {
              width: 100%;
              text-align: center;
            }
          }
        }
        .number {
          position: absolute;
          top: -100px;
          font-size: 80px;
          width: 100%;
          text-align: center;
          opacity: 0.8;
          display: none;
        }
      }
    }
  }

  &.activeAnimate {
    .swiper {
      &-container {
        transform: scale(0.6);
        overflow: unset;
      }
      &-wrapper {
        transition-delay: 0.3s;
      }
      &-slide {
        opacity: 1;
      }
    }
    .pagingControl {
      width: 90%;
      max-width: 90%;
    }
  }
  &.activeSeeAll {
    .swiper {
      &-container {
        transform: scale(0.6);
        overflow: unset;
      }
      &-wrapper {
        transition-delay: 0s;
      }
      &-slide {
        opacity: 1;
        padding: 50px 15px;
      }
    }
    .pagingControl {
      width: 90%;
      max-width: 90%;
    }

    .content-item {
      cursor: pointer;
    }
    .number {
      display: block !important;
    }
  }
  .pagingControl {
    display: flex;
    justify-content: space-between;
    position: absolute;
    bottom: 80px;
    left: 0;
    right: 0;
    width: 90%;
    // max-width: 800px;
    margin: 0 auto;
    transition: all 0.3s;
    border-bottom: 2px solid #fff;
    button {
      width: 0;
      height: 0;
      border: 0;
      position: relative;
      outline: none;
      cursor: pointer;
      transition: all 0.15s ease;
      background: transparent;
      &.active {
        .dot {
          transform: scale(3);
          background: #3aa0f3;
          border: 1px solid #fff;
        }
      }

      &.error {
        .dot {
          transform: scale(2);
          background: #df3030;
          border: 1px solid #fff;
        }
      }
      &.done {
        .dot {
          transform: scale(1.5);
          background: #6dbd00;
          border: 1px solid #fff;
        }
      }
      &:last-child .dot {
        left: 0px;
      }
      &:first-child .dot {
        left: -7px;
      }
      .dot {
        display: block;
        width: 10px;
        height: 10px;
        border-radius: 20px;
        border: 0;
        position: relative;
        left: -5px;
        top: -4px;
        background: #fff;
        transition: all 0.3s;
        box-shadow: #999 0 0 5px;
      }
      .tooltip {
        position: absolute;
        left: 0;
        bottom: 25px;
        background: rgba(#000, 0.75);
        transform: translateX(-50%);
        white-space: nowrap;
        color: #fff;
        padding: 10px;
        border-radius: 5px;
        opacity: 0;
        visibility: hidden;
        transition: all 0.3s;
      }
      &:hover {
        .dot {
          transform: scale(2);
        }
        .tooltip {
          opacity: 1;
          visibility: visible;
        }
      }
    }
  }
  .content-item {
    padding: 50px 40px;
    border-radius: 10px 10px 0 0;
    max-height: 50vh;
    overflow: auto;
    .heading {
      color: #323232;
      font-size: 24px;
      text-align: center;
      margin-bottom: 10px;
    }
    .text {
      color: #323232;
      font-size: 18px;
      text-align: center;
      margin: 0 auto;
      margin-bottom: 20px;
      max-width: 90%;
    }
    .small-text {
      color: #323232;
      font-size: 14px;
      text-align: center;
      margin-bottom: 20px;
      display: block;
    }
    &.dark {
      background: #007ce2;
      .heading,
      .text,
      .small-text {
        color: #fff;
      }
    }
  }
  .form-group {
    margin-bottom: 20px;
    .form-input,
    .form-textarea {
      width: 100%;
      border: 1px solid #a9b3c6;
      border-radius: 3px;
      padding: 0 10px;
      height: 50px;
      transition: all 0.3s;
      &:focus {
        box-shadow: 0 0 0 2px rgba(74, 133, 239, 0.3);
      }
      &.error {
        border: 1px solid #e34343;
      }
    }
    .form-textarea {
      height: 150px;
      resize: none;
      padding: 15px;
    }
  }
  .nav-control {
    background: #9dc83b;
    width: 100%;
    border-radius: 0 0 10px 10px;
    display: flex;
    overflow: hidden;
    position: relative;
    .error {
      position: absolute;
      top: 10px;
      color: #fff;
      background: rgba(0, 0, 0, 0.7);
      padding: 0.4em 0.8em;
      font-weight: 300;
      border-radius: 3px;
      font-size: 0.75em;
      cursor: none;
      &.step3 {
        left: calc(50% - 70px);
      }
    }
    button {
      width: 50%;
      height: 50px;
      color: #fff;
      text-transform: uppercase;
      padding: 0 30px;
      border: 0;
      background: #9ec83a;
      font-size: 18px;
      text-align: left;
      cursor: pointer;
      transition: all 0.3s;
      i {
        position: relative;
        right: 0.7em;
      }
      &:hover {
        background: #7ba21e;
      }
      &.nav-next {
        border-left: 1px solid #a9ce51;
        text-align: right;
        i {
          right: -0.7em;
        }
        &:hover i {
          animation: animateNext 1s 1;
        }
        &.no-back {
          width: 100%;
        }
      }
    }
  }
  .see-all {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 15px;
    margin: auto;
    width: 140px;
    height: 40px;
    background: #338dd7;
    border-radius: 3px;
    color: #fff;
    .text {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    button {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background: #338dd7;
      border: 0;
      color: #fff;
      border-radius: 3px;
      cursor: pointer;
      opacity: 0;
    }
    &:hover {
      button {
        opacity: 1;
      }
    }
  }
  .radio-item {
    width: 100%;
    position: relative;
    &:hover .hoverClass {
      width: 100%;
      z-index: 99;
      button {
        display: block;
      }
    }
    &.selected:hover .hoverClass {
      background: rgba(0, 0, 0, 0.15);
    }
    .hoverClass {
      position: absolute;
      width: 0;
      height: 100%;
      background: rgba(0, 0, 0, 0.7);
      z-index: -1;
      display: flex;
      justify-content: center;
      align-items: center;
      transition: all 0.4s ease-in-out;
      button {
        display: none;
      }
    }
    label {
      display: block;
      width: 100%;
      text-align: center;
      border: 1px solid #e5e5e5;
      border-radius: 5px;
      margin-bottom: 20px;
      padding: 15px;
      position: relative;
      cursor: pointer;
      transition: all 0.3s;
      // &:after {
      //   content: '';
      //   position: absolute;
      //   width: 15px;
      //   left: 15px;
      //   top: 10px;
      //   width: 15px;
      //   height: 15px;
      //   border: 1px solid #e5e5e5;
      //   border-radius: 10px;
      //   background: #fff;
      //   transition: all 0.3s;
      // }
      img {
        width: 90%;
      }
      &:hover {
        border-color: #5badfe;
      }
    }
    input[type='radio'] {
      display: none;
      &:checked ~ label {
        animation: blink2 0.15s linear 2 normal forwards;
      }
      &:checked ~ label:after {
        border-color: #5badfe;
        background: #5badfe;
        box-shadow: inset #fff 0 0 0 3px;
      }
    }
  }
  .form-upload {
    border: 2px dashed #4987c5;
    border-radius: 10px;
    background-color: #f4f7fa;
    padding: 16px;
    text-align: center;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    .ant-upload {
      border: none;
      background: #4987c5;
      color: #fff;
      margin: 0;
      margin: auto;
      float: none;
      &.ant-upload-select-picture-card {
        width: initial;
        height: initial;
        padding: 0 20px;
      }
    }
  }
}
@keyframes blink2 {
  0% {
    background-color: transparent;
    border-color: #a9b3c6;
  }
  100% {
    border-color: #5badfe;
    background-color: #d7ebff;
  }
}
@-webkit-keyframes animateNext {
  25% {
    right: -1.2em;
  }
  50% {
    right: -0.7em;
  }
  75% {
    right: -1em;
  }
  100% {
    right: -0.7em;
  }
}
@keyframes animateNext {
  25% {
    right: -1.2em;
  }
  50% {
    right: -0.7em;
  }
  75% {
    right: -1em;
  }
  100% {
    right: -0.7em;
  }
}

@keyframes shake-box {
  0% {
    transform: translateX(30px);
  }
  50% {
    transform: translateX(-30px);
  }
  100% {
    transform: translateX(0);
  }
}
.link-button {
  background: #1c84c6;
  color: #fff;
  font-size: 14px !important;
  height: 36px !important;
  border-radius: 13px !important;
  -webkit-box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25) !important;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25) !important;
  padding: 10px 15px;
}
</style>
